import React from 'react';
import { ChatMessage } from '../../pages/v3/components/chatMessage/ChatMessage';
import { ChatBackgroundRenderer } from './ChatBackgroundRenderer';
import { BackgroundImage } from '../../atoms/v3/chatPersonalizationAtoms';
import { Message } from '../../types';

interface ChatPreviewProps {
  background: BackgroundImage | null;
  mode: 'light' | 'dark';
  sampleUserMessage: Message;
  sampleAIMessage: Message;
  className?: string;
  title?: string;
  icon?: string;
}

const ChatPreviewComponent: React.FC<ChatPreviewProps> = ({
  background,
  mode,
  sampleUserMessage,
  sampleAIMessage,
  className = '',
  title,
  icon
}) => {
  return (
    <div className={`space-y-3 ${className}`}>
      {/* 标题 */}
      {title && (
        <div className="text-center">
          <h4 className="text-ios-footnote font-medium text-ios-gray dark:text-ios-dark-gray mb-2">
            {icon} {title}
          </h4>
        </div>
      )}

      {/* 预览容器 */}
      <div
        className={`relative rounded-lg overflow-hidden ${
          mode === 'dark'
            ? 'border border-ios-dark-gray4'
            : 'border border-ios-gray4'
        }`}
        style={{ minHeight: '200px' }}
      >
        {/* 背景渲染 */}
        <ChatBackgroundRenderer
          backgroundType={background ? (background.mediaType === 'video' ? 'video' : 'image') : 'solid'}
          backgroundImagePath={background ? background[mode].path : null}
          backgroundMediaType={background?.mediaType || null}
          backgroundObjectPosition={background ? background[mode].objectPosition || null : null}
          backgroundNeedsCrossfadeLoop={background ? background[mode].needsCrossfadeLoop || false : false}
          opacity={0.8}
          showVideoIndicator={true}
          className="absolute inset-0"
        />

        {/* 消息容器 */}
        <div className="relative z-10 p-4 space-y-3">
          <ChatMessage
            message={sampleUserMessage}
            onToggleExpand={() => {}}
            onToggleTask={() => {}}
            onTaskClick={() => {}}
            forceTheme={mode}
          />
          <ChatMessage
            message={sampleAIMessage}
            onToggleExpand={() => {}}
            onToggleTask={() => {}}
            onTaskClick={() => {}}
            forceTheme={mode}
          />
        </div>
      </div>
    </div>
  );
};

// 使用React.memo优化，只有关键props变化时才重新渲染
export const ChatPreview = React.memo(ChatPreviewComponent, (prevProps, nextProps) => {
  return (
    prevProps.background?.id === nextProps.background?.id &&
    prevProps.mode === nextProps.mode &&
    prevProps.sampleUserMessage.id === nextProps.sampleUserMessage.id &&
    prevProps.sampleAIMessage.id === nextProps.sampleAIMessage.id &&
    prevProps.title === nextProps.title &&
    prevProps.icon === nextProps.icon &&
    prevProps.className === nextProps.className
  );
});
